import React from 'react'
import LoginNavbar from '../Layouts/LoginNavbar'
import LoginForm from '../Components/Login_Components/Login/LoginForm'

const login = () => {
  return (
    <div>
      <LoginNavbar/>
      <LoginForm/>
    </div>
  )
}

export default login